import { useQuery } from '@tanstack/react-query';

import { canViewMaturityModelPage, getMaturityModelOptions, getMaturityModels } from '../api';
import { type MaturityModel } from '../types';

export const MATURITY_MODEL_OPTIONS_ID = 'maturity-model-options';
export const MATURITY_MODELS_ID = 'maturity-models';

export const useMaturityModelOptions = () =>
  useQuery({
    queryKey: [MATURITY_MODEL_OPTIONS_ID],
    queryFn: getMaturityModelOptions,
    staleTime: 1000 * 60 * 5,
  });

export const useMaturityModels = (initialData?: MaturityModel[]) =>
  useQuery({
    queryKey: [MATURITY_MODELS_ID],
    queryFn: getMaturityModels,
    staleTime: 1000 * 60 * 5,
    initialData,
  });

export const useCanViewMaturityModelPage = (enabled = true) =>
  useQuery({
    queryKey: ['can-view-maturity-model-page'],
    queryFn: canViewMaturityModelPage,
    staleTime: 1000 * 60 * 15,
    enabled,
  });
